import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "results", "option"]

  connect() {
    this.activeIndex = -1
    this.dismissed = false
    this.setExpanded(false)
  }

  input() {
    this.dismissed = false
    this.resetActiveOption()

    if (this.inputTarget.value.trim()) {
      this.open()
    } else {
      this.close()
    }
  }

  resultsLoaded() {
    this.resetActiveOption()

    if (this.dismissed) return

    this.resultsTarget.hidden = false
    this.setExpanded(this.optionTargets.length > 0)
  }

  open() {
    if (!this.hasResultsTarget || this.optionTargets.length === 0) return

    this.dismissed = false
    this.resultsTarget.hidden = false
    this.setExpanded(true)
  }

  close() {
    this.dismissed = true
    this.resetActiveOption()
    if (this.hasResultsTarget) this.resultsTarget.hidden = true
    this.setExpanded(false)
  }

  clickOutside(event) {
    if (!this.element.contains(event.target)) this.close()
  }

  keydown(event) {
    switch (event.key) {
      case "ArrowDown":
        event.preventDefault()
        this.open()
        this.moveActiveOption(1)
        break
      case "ArrowUp":
        event.preventDefault()
        this.open()
        this.moveActiveOption(-1)
        break
      case "Enter":
        if (this.activeIndex < 0) return

        event.preventDefault()
        this.optionTargets[this.activeIndex].click()
        break
      case "Escape":
        if (this.inputTarget.getAttribute("aria-expanded") !== "true") return

        event.preventDefault()
        this.close()
        break
      case "Tab":
        this.close()
        break
    }
  }

  moveActiveOption(direction) {
    if (this.optionTargets.length === 0) return

    const lastIndex = this.optionTargets.length - 1
    if (this.activeIndex < 0) {
      this.activeIndex = direction > 0 ? 0 : lastIndex
    } else {
      this.activeIndex = (this.activeIndex + direction + this.optionTargets.length) % this.optionTargets.length
    }

    const activeOption = this.optionTargets[this.activeIndex]
    this.optionTargets.forEach((option, index) => {
      option.setAttribute("aria-selected", index === this.activeIndex ? "true" : "false")
    })
    this.inputTarget.setAttribute("aria-activedescendant", activeOption.id)
    activeOption.scrollIntoView({ block: "nearest" })
  }

  resetActiveOption() {
    this.activeIndex = -1
    this.inputTarget.removeAttribute("aria-activedescendant")
    this.optionTargets.forEach((option) => option.setAttribute("aria-selected", "false"))
  }

  setExpanded(expanded) {
    this.inputTarget.setAttribute("aria-expanded", expanded ? "true" : "false")
  }
}
